<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div *ngIf="isWindFarmView || isPowerStationAdminView" class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div [ngClass]="isWindFarmView || isPowerStationAdminView ? 'col-md-10' : 'col-md-12'">
            <card-section-header
                title="Invited Users"
                icon="fas fa-list"
                [showButton]="false">
            </card-section-header>
            <div class="mb-2 animated fadeIn">
              <div class="form-row">
                <div class="col-md-12 d-flex justify-content-end">
                  <table-action-bar (toggleColumns)="columnOptionsSidebarVisible = true"></table-action-bar>
                </div>
              </div>
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table [value]="siteWorkers" [autoLayout]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Name</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Username')">Username</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Phone')">Phone</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Company')">Company</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Company')">Company Approved</th>
                            <th class="table-cell-centered">Activated</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Competencies')">Competencies</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Asset Categories')">Asset Categories</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Guests Permitted')">Guests Permitted</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Site Session Permitted')">Site Session Permitted</th>
                            <th *ngIf="tableOptions.visibleColumns.includes('Site Delegate')">Site Delegate</th>
                            <th *ngIf="hasInduction && tableOptions.visibleColumns.includes('Induction')">Induction</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-worker>
                      <ng-container *ngIf="loading; else showRows">
                          <tr>
                            <td [attr.colspan]="20">
                              <skeleton-loading-row></skeleton-loading-row>
                            </td>
                          </tr>
                      </ng-container>
                      <ng-template #showRows>
                        <tr>
                          <td>
                            <a *ngIf="isPowerStationAdminView || isWindFarmView; else noLink" [routerLink]="['/' + routeRole, 'workers', worker.workerUser.id, 'sites']"
                            [queryParams]="{ backLink:  '/' + routeRole + '/sites/' + selectedSite.id + '/invited-users', siteOwnerId: selectedSite.siteOwner.id }"
                            >
                              {{ worker.workerUser.firstName }} {{ worker.workerUser.lastName }}
                            </a>
                            <ng-template #noLink>
                              {{ worker.workerUser.firstName }} {{ worker.workerUser.lastName }}
                            </ng-template>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Username')">{{ worker.workerUser.login }}</td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Phone')">{{ worker.workerUser.workerUser.phoneNumber }}</td>
                          <td *ngIf="isSiteDelegate && tableOptions.visibleColumns.includes('Company')">
                              {{ worker.workerUser.workerUser.maintenance.name }}
                          </td>
                          <td *ngIf="!isSiteDelegate && tableOptions.visibleColumns.includes('Company')">
                            <a [routerLink]="['/' + routeRole, 'contractors', worker.workerUser.workerUser.maintenance.id, 'details']">
                              {{ worker.workerUser.workerUser.maintenance.name }}
                            </a>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Company')">
                            <span *ngIf="worker.contractorStatus === 'APPROVED'" class="badge badge-pill badge-success">Approved</span>
                            <span *ngIf="worker.contractorStatus !== 'APPROVED'" class="badge badge-pill badge-warning">Not Approved</span>
                          </td>
                          <td class="table-cell-centered">
                            <ng-container *ngIf="worker.workerUser.activated; else notActivated">
                              <i class="fas fa-check-circle success"></i>
                            </ng-container>
                            <ng-template #notActivated>
                              <i class="fas fa-times-circle danger"></i>
                              <div>
                                <button type="button" class="btn btn-primary btn-link"
                                  [disabled]="worker.workerUser.isSendingInvite || worker.workerUser.inviteSent" (click)="$event.stopPropagation(); resendInvite(worker.workerUser)">
                                  <span *ngIf="!worker.workerUser.isSendingInvite && !worker.workerUser.inviteSent">Resend invite</span>
                                  <span *ngIf="worker.workerUser.isSendingInvite">
                                    <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                    Sending...
                                  </span>
                                  <span *ngIf="worker.workerUser.inviteSent">Invite sent</span>
                                </button>
                              </div>
                            </ng-template>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Competencies')" >
                            <div class="competency-container">
                              <ng-container *ngIf="!hasReliableCompetencyCounts; else competencyCountsReady">
                                <div class="skeleton competency-count-skeleton"></div>
                                <div class="skeleton competency-status-skeleton"></div>
                              </ng-container>
                              <ng-template #competencyCountsReady>
                                <ng-container *ngIf="isPowerStationAdminView || isWindFarmView; else noCompetencyLink">
                                  <a
                                    class="link-underline"
                                    [routerLink]="['/' + routeRole, 'workers', worker.workerUser.id, 'manage-competencies']"
                                    [queryParams]="{ backLink:  '/' + routeRole + '/sites/' + selectedSite.id + '/invited-users', siteOwnerId: selectedSite.siteOwner.id }">
                                    {{ getCompetencyCountLabel(worker) }}
                                  </a>
                                </ng-container>
                                <ng-template #noCompetencyLink>
                                  <span>{{ getCompetencyCountLabel(worker) }}</span>
                                </ng-template>
                                <ng-container *ngIf="getCompetencyStatusItems(worker) as statusItems">
                                  <div class="competency-container__text-size" *ngIf="statusItems.length">
                                    <ng-container *ngFor="let item of statusItems; let last = last">
                                      <span [ngClass]="item.colorClass"><strong>{{ item.count }}</strong></span>
                                      <span> {{ item.label }}</span><span *ngIf="!last">, </span>
                                    </ng-container>
                                  </div>
                                </ng-container>
                              </ng-template>
                            </div>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Asset Categories')">
                            <span *ngFor="let item of worker.assetCategories" class="badge badge-pill badge-success" [ngStyle]="{ 'background-color': item.color }">{{ item.name }}<br /></span>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Guests Permitted')" class="table-cell-centered">
                            <span *ngIf="worker.guestsPermitted"><i class="fas fa-check-circle success"></i></span>
                            <span *ngIf="!worker.guestsPermitted"><i class="fas fa-times-circle danger"></i></span>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Site Session Permitted')" class="table-cell-centered">
                            <span *ngIf="worker.managementDuty"><i class="fas fa-check-circle success"></i></span>
                            <span *ngIf="!worker.managementDuty"><i class="fas fa-times-circle danger"></i></span>
                          </td>
                          <td *ngIf="tableOptions.visibleColumns.includes('Site Delegate')" class="table-cell-centered">
                            <span *ngIf="worker.siteDelegate"><i class="fas fa-check-circle success"></i></span>
                            <span *ngIf="!worker.siteDelegate"><i class="fas fa-times-circle danger"></i></span>
                          </td>
                          <td *ngIf="hasInduction && tableOptions.visibleColumns.includes('Induction')">
                            <ng-container *ngIf="worker.inductionForSite && worker.inductionForSite.courseProgress === TrainingCourseStateType.Completed">
                              <span class="badge badge-pill badge-success">
                                valid until: {{ worker.inductionForSite.expiryDate | date : 'mediumDate' }}
                              </span>
                            </ng-container>
                            <ng-container *ngIf="worker.inductionForSite && worker.inductionForSite.courseProgress === TrainingCourseStateType.Expired">
                              <span class="badge badge-pill badge-warning">
                                expired on: {{ worker.inductionForSite.expiryDate | date : 'mediumDate' }}
                              </span>
                            </ng-container>
                            <ng-container *ngIf="!worker.inductionForSite">
                              <span class="badge badge-pill badge-danger">
                                Not Verified
                              </span>
                            </ng-container>
                          </td>
                        </tr>
                      </ng-template>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr *ngIf="loading">
                        <td [attr.colspan]="20">
                          <skeleton-loading-row></skeleton-loading-row>
                        </td>
                      </tr>
                      <tr *ngIf="!loading">
                        <td [attr.colspan]="12">No invited users found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="1000000">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of togglableColumns">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <div class="form-group" [ngClass]="!hasInduction ? 'text-muted' : ''">
    <p-checkbox name="togglableColumns" [disabled]="!hasInduction" [value]="'Induction'" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="'Induction'"></p-checkbox>
    <div class="text-muted small" *ngIf="!hasInduction">No induction on this site</div>
  </div>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
